<template>
    <div class="card summary-item">
        <div class="card-content-wrapper card-link-wrapper">
            <div class="card-body">
                <a v-if="hasVideo" v-bind:href="findVideo[0].Url" class="thumb-video open-self video card-video">
                    <div class="img-container">
                        <img class="card-media" v-bind:alt="item.Title" v-bind:src="image" />
                        <span class="play-btn"></span>
                        <span class="sr-only">iframe video</span>
                    </div>
                </a>
                <img class="card-media" v-if="!hasVideo" v-bind:alt="item.Title" v-bind:src="image" />
                <div class="card-body-content-wrapper">
                    <h2 class="card-title">{{ item.Title }}</h2>
                </div>
                <div class="card-cta" :class="{ 'story-cta': isStory }">
                    <a v-if="hasVideo" class="link video-link open-self video card-video"
                       v-bind:href="findVideo[0].Url">{{ findVideo[0].Text }}</a>
                    <div v-if="hasCopyLink" class="link"
                         v-bind:href="returnCopyLinkCTA[0].Url"
                         @click="checkforCopyLink($event, returnCopyLinkCTA[0].Type.CodeName, returnCopyLinkCTA[0].Url)">{{ returnCopyLinkCTA[0].Text }}</div>
                    <a v-if="hasGenericCTA" class="link"
                       v-bind:href="returnGenericCTA[0].Url"
                       target="_blank">{{ returnGenericCTA[0].Text }}</a>
                </div>
                <div v-if="item.OptionalSecondaryCta" class="card-cta">
                    <a class="link"
                       v-bind:href="item.OptionalSecondaryCta.Url"
                       target="_blank">{{ item.OptionalSecondaryCta.Text }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import imageOptimizer from '../../../common/utils/image-optimizer';

    export default {
        props: ['item'],
        components: {

        },
        computed: {
            types: function () {
                if (this.item.Tags) {
                    return this.item.Tags.filter((item) => {
                        return item.Type.CodeName == 'Types';
                    }).slice(0, 2);
                } else {
                    return [];
                }
            },
            image: function () {
                let html = document.querySelector('html');

                if (html.classList.contains('webp')) {
                    if (this.item.Image !== null && this.item.Image !== "") {
                        return imageOptimizer.getOptimizedImageUrl(this.item.Image, 'webp');
                    }
                    else {
                        return '/content/images/content-placeholder.webp';
                    }
                }
                else {
                    if (this.item.Image !== null && this.item.Image !== "") {
                        return imageOptimizer.getSanitizeMediaUrl(this.item.Image);
                    }
                    else {
                        return '/content/images/content-placeholder.png';
                    }
                }
            },
            hasVideo: function () {
                let check = this.item.Cta.filter(function (x) {
                    if (x.Type.CodeName == 'Video') {
                        return true;
                    } else {
                        return false;
                    }
                });

                if (check.length > 0) {
                    return true;
                } else {
                    return false;
                }
            },
            findVideo: function () {
                let check = this.item.Cta.filter(function (x) {
                    if (x.Type.CodeName == 'Video') {
                        return true;
                    } else {
                        return false;
                    }
                });

                return check;
            },
            hasCopyLink: function () {
                let check = this.item.Cta.filter(function (x) {
                    if (x.Type.CodeName == 'CopyLink') {
                        return true;
                    } else {
                        return false;
                    }
                });

                if (check.length > 0) {
                    return true;
                } else {
                    return false;
                }
            },
            returnCopyLinkCTA: function () {
                let check = this.item.Cta.filter(function (x) {
                    if (x.Type.CodeName == 'CopyLink') {
                        return true;
                    } else {
                        return false;
                    }
                });

                return check;
            },
            hasGenericCTA: function () {
                let check = this.item.Cta.filter(function (x) {
                    if (x.Type.CodeName == 'CTA') {
                        return true;
                    } else {
                        return false;
                    }
                });

                if (check.length > 0) {
                    return true;
                } else {
                    return false;
                }
            },
            returnGenericCTA: function () {
                let check = this.item.Cta.filter(function (x) {
                    if (x.Type.CodeName == 'CTA') {
                        return true;
                    } else {
                        return false;
                    }
                });

                return check;
            },
            isStory: function () {
                let check = this.item.Type.CodeName;
                let needle = 'Story';

                return check.includes(needle);
            }
        },
        mounted: function () {
        },
        methods: {
            checkforCopyLink: function (e, codeName, url) {
                if (codeName === 'CopyLink') {
                    e.preventDefault();
                    e.stopPropagation();
                    navigator.clipboard.writeText(url).then(function () {
                        alert('Link has been copied!')
                    });
                }
            }
        },
    }
</script>